var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"id":"Regular","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('title',[_vm._v("chevron")]),_c('path',{staticClass:"chevron-path path",attrs:{"d":"M5.5.75,16.22,11.47a.749.749,0,0,1,0,1.06L5.5,23.25"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }